// Polyfills para navegadores antigos (Safari < 15.4, Chrome < 98, Firefox < 90).
// Aplicados de forma condicional e não-destrutiva: só definem o que não existe.

const g = globalThis as any;

if (typeof Object.hasOwn !== "function") {
  Object.hasOwn = (obj: object, key: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(obj, key);
}

if (!Array.prototype.at) {
  (Array.prototype as any).at = function at(index: number) {
    const i = index >= 0 ? index : this.length + index;
    return this[i];
  };
}

if (typeof String.prototype.replaceAll !== "function") {
  (String.prototype as any).replaceAll = function replaceAll(
    search: string | RegExp,
    replacement: string,
  ) {
    if (search instanceof RegExp) {
      return String(this).replace(search, replacement);
    }
    return String(this).split(search).join(replacement);
  };
}

const cryptoObj = g.crypto;
if (cryptoObj && typeof cryptoObj.randomUUID !== "function") {
  cryptoObj.randomUUID = function randomUUID() {
    // Fallback não-criptográfico; suficiente para gerar IDs únicos de UI.
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c: string) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
}
